// filters.ts

// Action Types
export const SET_FILTERS = 'SET_FILTERS';
export const RESET_FILTERS = 'RESET_FILTERS';

// Action Interfaces
interface SetFiltersAction {
    type: typeof SET_FILTERS;
    payload: any[];
}

interface ResetFiltersAction {
    type: typeof RESET_FILTERS;
}

export type FilterActionTypes = SetFiltersAction | ResetFiltersAction;

// Action Creators
export const setFilters = (filters: any[]): FilterActionTypes => ({
    type: SET_FILTERS,
    payload: filters
});

export const resetFilters = (): FilterActionTypes => ({
    type: RESET_FILTERS
});
